import { useState } from "react";
import { Sparkles, X } from "lucide-react";
import { useT } from "../../i18n/LanguageContext";
import { isPreOpening } from "../../lib/openingDate";

export default function AvailabilityBar() {
  const { t } = useT();
  const [open, setOpen] = useState(true);
  if (!isPreOpening()) return null;
  if (!open) return null;
  return (
    <div className="bg-noite text-[#faf6ee] py-2 px-4" data-testid="availability-bar">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-xs sm:text-sm">
        <Sparkles size={14} className="text-[#e3b25b] flex-shrink-0" />
        <p className="text-center font-medium tracking-wide">{t.availability}</p>
        <button
          onClick={() => setOpen(false)}
          aria-label="Fechar"
          className="ml-auto opacity-60 hover:opacity-100 transition flex-shrink-0"
          data-testid="availability-close"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
